import {
  responsive,
  VStack,
  useResponsive,
  colors,
  dableCustomEvent,
  DableEventName,
} from "goi_common";
import GuideHead from "./components/Guide/GuideHead";
import { Stack } from "@chakra-ui/react";
import GuideBox from "./components/Guide/GuideBox";
import GuideContent from "./components/Guide/GuideContent";
import GuideFooter from "./components/Guide/GuideFooter";
import Footer from "../Home/components/Footer";
import { useViewpostTopObserver } from "@/hooks/useViewpostTopObserver";
import LandingFixedButton from "@/components/common/LandingFixedButton";
import { useEffect } from "react";

export default function ContentFirstSnGuide() {
  const { isBiggerThanLg } = useResponsive();
  const { viewportTopRef } = useViewpostTopObserver();

  useEffect(() => {
    dableCustomEvent(DableEventName.PageView);
  }, []);

  return (
    <VStack width="100%" alignItems="center">
      <div ref={viewportTopRef}></div>
      <GuideHead
        title="장례 가이드북 1편 - 장례 전"
        date="2021년 02월 08일 작성"
        imgSrc="direct/content/sn/1-hero.png"
      />
      <Stack
        maxWidth={`720px`}
        width="100%"
        css={responsive({
          gap: { base: "28px", md: "40px" },
          padding: { base: "0", lg: "60px 0px" },
        })}
      >
        <GuideBox>
          해당 글은 고이 송슬옹 대표가 직접 작성한 모 커뮤니티 베스트 게시글의
          내용을 가져왔으며,
          {!isBiggerThanLg && <br />}
          <br />글 중간의 이미지 추가, 오타 수정 등으로 원글과 다른 내용이 있을
          수 있습니다.
        </GuideBox>

        <GuideContent contents={FIRST_SNU_CONTENT} />

        <GuideFooter />
      </Stack>
      <LandingFixedButton
        color={colors.brown650}
        text="고이와 함께 장례 준비하기"
        eventPath="content_sn_1"
        onClick={() => {
          dableCustomEvent(DableEventName.ViewContent);
        }}
      />
      <Footer />
    </VStack>
  );
}

const FIRST_SNU_CONTENT: Array<{
  type: "p" | "img" | "h2" | "h3" | "h4" | "button" | "a";
  resource: string;
  imgAlt?: string;
  onClick?: () => void;
  href?: string;
  newGtm?: {
    path: string;
    trigger_and_target: string;
  };
}> = [
  {
    type: "p",
    resource:
      "안녕하세요. 학부 출신 현직 장례지도사입니다.\nOOOOO를 보던 중 '장례 절차 및 비용에 대하여'라는 게시글을 보고 처음으로 OOOOO에 글을 올리기로 결심했습니다.\n\n장례식 하나도 감당하기 벅찰텐데, 줄초상이라니 정말 안타까운 마음이 들면서 다른 분들을 위해 일목요연하게 경험을 정리해서 업로드하신 걸 보고 정말 대단하다는 생각을 했습니다. 그래서 제가 장례지도사로 일하면서 보고 배운 것들을 공유하면 누군가에게 큰 도움이 될 수도 있다는 생각을 했습니다. 시점에 따라 장례 전, 장례 중, 장례 후로 나누어 총 3편의 글을 연재 할 계획이며, 피할 수 없는 일이라면 미리 잘 알고 대처하시길 바라는 마음에서 글을 시작합니다.",
  },
  { type: "img", resource: "direct/content/sn/1-1.png", imgAlt: "장례 준비" },
  {
    type: "h2",
    resource:
      "임종 전 준비, 결정할 것은 장례지도사, 장례식장, 안치 방법 3가지입니다.",
  },
  { type: "h3", resource: "1. 장례지도사 선택" },
  {
    type: "p",
    resource:
      "<u>상조회사에서 장례를 치를거냐? 장례식장에서 할거냐?</u> 등의 질문은 결국 어떤 조직에 속한 장례지도사를 이용할 것이냐?라는 물음으로 귀결됩니다. 장례 업계는 결혼 업계와 굉장히 유사한데, 장례 준비를 결혼 준비 과정으로 이해한다면 <u>상조회사의 장례지도사는 동행 플래너, 장례식장의 장례지도사는 비동행 플래너(반워킹)과 유사하다고 보시면 됩니다.</u>",
  },
  {
    type: "h4",
    resource: "1) 상조회사 VS 장례식장 = 동행 플래너 VS 비동행 플래너",
  },
  {
    type: "p",
    resource:
      "즉 상조 회사를 이용하면 3일 동안 유족의 옆에 붙어서 시점별로 무엇을 어떻게 해야 하는지 알려주고, 장례 전후 필요한 행정적 절차, 의례 절차를 수행해줍니다. 그만큼 인력 서비스에 대한 비용을 지불하는 것이죠. 반면 장례식장을 이용하면 장례 지도사가 유족 옆에 붙어있지 않습니다. 다만 장례식장 사무실에 방문해서 직접 요청할 경우에 도움을 받을 수 있습니다. 따라서 장례식 절차에 대해 인지하고 있거나, 교회 장례전담팀이 있을 경우 장례식장 소속 장례지도사를 이용하면 상대적으로 저렴한 비용으로 장례를 치를 수 있습니다.",
  },
  {
    type: "img",
    resource: "direct/content/sn/1-2.png",
    imgAlt: "장례 준비 방법",
  },
  {
    type: "h4",
    resource: "2) 선불 상조 회사 VS 후불 상조회사 = 대형 프랜차이즈 VS 소규모 ",
  },
  {
    type: "p",
    resource:
      "상조회사는 다시 선불과 후불 상조회사로 나뉩니다. 엄밀하게 말해서 선불 상조 회사는 선불식 할부 거래업으로 분류되어 공정거래위원회에서 관리하는데요, 목돈을 갑자기 준비하기 어려운 분들을 위해 미래에 발생할 비용을 할부로 구매할 수 있도록 합니다. 그래서 좋게 말하면 인플레이션 리스크를 대비하는 기능이 있습니다.(물가가 폭등해도 현재 시점에서 약정한 금액으로 각종 물품과 인력 서비스 등을 이용할 수 있음)",
  },
  {
    type: "p",
    resource:
      "그리고 모든 상조 회사는 누가 언제 죽을지 모르니 사전에 고객을 확보하기 위해 노력하는데, 상조 영업 사원 또는 TV광고, 검색 광고 등으로 과도한 영업/마케팅을 하기 때문에 해당 비용이 고객에게 전가됩니다. Dart 공시 자료로 주요 상조 회사의 재무제표를 보면 확인하실 수 있습니다. <u>평균 가격은 4~500만원이며, 경우에 따라 7~800만원</u>을 이용할 수도 있습니다. 다만 <u>안정적이고 표준화된 서비스를 받을 수 있기에 100~200만원 정도의 돈이 크게 상관없는 분들이라면 큰 상조 회사에서 서비스를 받으셔도 괜찮습니다.</u>",
  },
  {
    type: "img",
    resource: "direct/content/sn/1-3.png",
    imgAlt: "장례 준비 필요한 것",
  },
  {
    type: "p",
    resource:
      "후불제 상조 회사의 경우 위의 선불 상조 회사에서 일하다가 나와서 사업을 시작한 경우가 많습니다. 그래서 장례 서비스 및 용품은 질적으로 차이가 없습니다. <u>평균 가격은 250~300만원</u> 정도로 형성되어 있습니다. 다만 후불제 상조를 고를 때 는 너무 영세한 곳보다는 고객 후기가 쌓여 있고, 업력이 3~4년 정도 되는 곳을 찾는 등 발품을 파는 노력이 필요합니다. 또한 <u>실질적으로 장례식의 만족도는 '내가 어떤 장례지도사를 만나는가?'에 달려있기에 상담 전화</u>를 통해 친절함, 전문성 등을 사 전에 확인하는 일이 필요합니다.",
  },
  { type: "h3", resource: "2. 장례식장 선택" },
  {
    type: "p",
    resource: "비용, 시설, 위치, 서비스, 방역 5가지 요소를 고려하시면 됩니다.",
  },
  {
    type: "img",
    resource: "direct/content/sn/1-4.png",
    imgAlt: "장례 준비할 때",
  },
  { type: "h4", resource: "1) 장례식장 비용 = 시설 사용료 + 음식료 + 제단꽃" },
  {
    type: "p",
    resource:
      "대부분의 사람들이 상조 회사를 통해 장례를 치르기에, 해당 경우를 전제하고 장례식장 비용을 설명드리겠습니다. 먼저 시설 사용료는 빈소, 접객실, 안치실 등의 공간을 임대하는 비용인데 <u>국공립 의료원, 전문 장례식장, 대형 병원 장례식장으로 갈수록 가격이 높습니다.</u> 정확한 가격은 e-하늘 장사 정보 시스템에서 확인하실 수 있습니다. 빈소+접객실 1일 임대료를 기준으로 비교하시면 됩니다.",
  },
  {
    type: "p",
    resource:
      "<b>음식 비용은 일회용품, 음료 및 주류, 국/밥/반찬 등으로 구성되어 있는데 <u>1인당 2만원 정도이며, 이것 역시 좋은 장례식장일 수록 조금씩 비싸집니다.</u> 조문객을 예상한 뒤, 1인당 비용을 곱하면 대략적으로 음식 비용을 예측할 수 있습니다. 보통 조문객 200명을 가정하는데, 이 경우 400만원이 소요되는 식입니다.</b>\n\n제단꽃은 영정사진 주위를 장식하는 꽃 일체를 말합니다. <u>보통 40만원 ~ 100만원 사이</u>에서 결정하시는데, 장례식장마다 지정된 협력업체가 있어서 장례식장에서 제시하는 제단꽃 내에서 선택해야 합니다.",
  },
  {
    type: "img",
    resource: "direct/content/sn/1-5.png",
    imgAlt: "장례 준비 장례식장",
  },
  { type: "h4", resource: "2) 기타" },
  {
    type: "p",
    resource:
      "시설 : 시설이야 비쌀수록 좋겠지만, 결국 <u>실질적으로 중요한 장소는 빈소 내 유족 대기실과 입관실</u>입니다. 3일 장례를 치를 때 심리적 고통뿐만 아니라 제대로 쉬지 못해서 발생하는 육체적 고통도 크게 다가옵니다. 따라서 상중에도 편하게 쉴 수 있 는 공간이 마련되어 있는 것이 좋은데, 대부분의 고객들이 미리 답사를 올 때 대기실을 확인하지 않더라구요. 한편 입관의 경우 장례 1~2일차에 고인의 얼굴을 마지막으로 보고 시신을 관에 넣어 작별을 하는 의례를 말합니다. 3~40분 정도 의례가 진행되는데, 입관실은 충분히 넓은지, 불쾌한 냄새가 나지는 않는지, 참관실은 별도로 마련되어 있는지 등을 확인하시면 좋습니다",
  },
  {
    type: "p",
    resource:
      "끝으로 <u>조문객이 많이 오는 장례의 경우 주차장도 중요합니다.</u> 기껏 조문을 왔는데 마땅히 주차할 곳이 없을 수도 있습니다 그래서 주차장 여석을 확인하고, 주차 관리가 잘 되는지 확인해보시는 일도 필요합니다.",
  },
  {
    type: "p",
    resource:
      "위치 : 요새는 장례식장에 3일 내내 머무르기보다 빈소를 지킬 사람을 정하고 나머지 사람들은 집과 장례식장을 왔다갔다 하는 경우가 많습니다. 따라서 자택과 가까운 곳을 선정하는 것이 좋은데, 형제가 많다면 중간 위치 또는 교통이 편리한 곳을 선 정하시면 됩니다.",
  },
  {
    type: "p",
    resource:
      "서비스 : 상조회사에서 나온 장례지도사 못지 않게 <u>장례식장의 직원과 소통해야 하는 일이 많습니다.</u> 음식 주문부터 제단꽃 설치, 영정사진 제작, 비용 결제, 냉난방 관리, 청소 등의 일은 장례식장 직원과 말해야 합니다. 따라서 사전에 방문해서 직원이 친절하게 응대하는지 꼭 확인하시길 추천드립니다. 대부분 친절하게 응대하나, 진짜 친절은 번거롭고 어려운 부탁일 때 나타나고는 합니다.",
  },
  {
    type: "p",
    resource:
      "제가 추천드리는 방법은 <u>음식 반입이 가능한지 물어보는 것입니다.</u> 장례식장은 음식 장사라고 하는데, 그만큼 음식에서 발생 하는 이익이 높습니다. 따라서 음식 반입이 가능한지 물어보았을 때 어떻게 응대하는지 살펴보시면 직원의 친절함을 가늠할 수 있습니다. <u>물론 식중독 등의 위생상 이유로 대부분 어렵다고 대답합니다. 그럼에도 불구하고</u> 명확한 규정을 근거로 답변 을 하는지, 고객의 요구에 대해 장례식장 입장을 관철시킬 때 어떤 태도를 보이는지 등을 확인할 수 있습니다",
  },
  {
    type: "p",
    resource:
      "방역 : 장례식장에서 집단 코로나 감염 사태가 종종 보도되고 있습니다. 보건복지부 지침에 따라 30분 이상 머무르지 않고, 음식을 먹지 않는 등의 거리두기 지침이 권장되고 있으나 실제로 잘 지켜지지 않습니다. 따라서 적어도 출입자의 명부를 기록하고 체온을 측정하며 손 소독을 실시하는 등의 최소한의 방역을 하고 있는지 확인하시길 추천드립니다. 유족과 조문객이 방역 수칙을 지키려는 노력이 더욱 중요하겠지만, <u>최소한의 환경을 장례식장이 마련해주는지 확인해보세요.</u>",
  },
  { type: "img", resource: "direct/content/sn/1-6.png", imgAlt: "장례 준비" },
  { type: "h3", resource: "3. 안치 방법 선택" },
  { type: "h4", resource: "1) 1차 장지 : 화장 vS 매장" },
  {
    type: "p",
    resource:
      "장례 이후 시신을 어떻게 모실지 결정하는 일입니다. 화장과 매장에 따라 비용과 절차가 상이하기 때문에 적어도 이것만큼은 사전에 가족끼리 합의하는 것이 좋습니다. 특히 선산이 있는 경우 형제들 간의 의견 차이로 인해 싸우는 경우가 많습니다. 어떤 방법이 더 좋다고 추천드리기는 어렵지만, 매장은 묘지 이외에 다른 방법으로 시신을 안치할 수 없습니다. <u>화장은 아래에 설명드리는 모든 방법이 가능하며, 상대적으로 가격이 낮습니다. 관내의 경우 10만원, 관외의 경우 100만원이 소요됩니다.</u>",
  },
  { type: "h4", resource: "2) 2차 장지 : 묘지 / 납골 / 자연장" },
  {
    type: "p",
    resource:
      "<u>유족이 가장 신경쓰지 못하지만, 가장 큰 비용의 차이를 불러오는 것이 바로 2차 장지입니다.</u> 묘지에 시신을 모시는 경우는 1%도 안되기에 납골과 자연장만 설명드리겠습니다. 공공 시설을 이용하는 것이 가장 좋지만, 지역 주민이 아니라면 이용하기 어렵기 때문에 대부분 사설을 이용하게 됩니다. <u>사설 납골/수목장의 경우 최소 300만원에서 1000만원, 더 높게는 3000~4000만원도 있습니다. 일반적으로 수목장이 납골에 비해 10~20% 더 비쌉니다.</u>\n\n<b>이때 고객이 스스로 납골당(봉안당), 수목장을 찾지 못하니 장례지도사의 소개로 2차 장지를 결정합니다. 따라서 자연스럽게 사설 봉안당과 수목장이 고객을 많이 유치하는 방법은 고객에게 서비스를 더 잘 주는 것이 아니라 장례지도사에게 소개 수수료를 더 많이 지급하는 것입니다. 업계에서는 리베이트(줄여서 RT)라고 말하는데, 적게는 20%에서 많게는 40%까지 장례지도사에게 줍니다.</b>",
  },
  { type: "img", resource: "direct/content/sn/1-7.png", imgAlt: "장례 준비" },
  {
    type: "p",
    resource:
      "따라서 장례지도사 입장에서는 효심을 건들이면서 비싼 봉안당, 그 중에서도 사용료가 높은 중간 칸(아파트처럼 층마다 가격이 다르게 분양이 이루어지는데, 고층과 저층은 싸고 시선의 높이에 있는 중간층이 비쌉니다)을 권유하기 쉽습니다. <u>대부분의 양심적인 장례지도사는 유족의 의사를 충분히 듣고, 뜻을 존중해주려고 합니다.</u> 그러나 유족이 스스로 결정을 내리기 어려운 상황이다보니 장례지도사의 권유에 따르는 경우가 많기에 이를 이용하여 <u>자신에게 더 많은 이익이 발생하는 곳으로 유도를 하는 경우도 있습니다.</u> 따라서 2차 장지만큼은 꼭 사전에 알아보는 것을 추천드립니다. 인터넷으로 (지역) + (납골당/봉안당/수목장)을 검색하셔서 상담을 받아보면 비교 견적을 하실 수 있습니다.",
  },
  { type: "img", resource: "direct/content/sn/1-8.png", imgAlt: "장례 준비" },
  {
    type: "p",
    resource:
      "지금까지 장례 전에 가족이 준비해야 할 사항을 정리했습니다. 당장은 필요없겠지만, 만약이라도 장례를 준비해야할 상황이 온다면 글이 조금이라도 도움이 되었으면 좋겠습니다. 장례에 관해 궁금한 사항이 있다면 댓글로 남겨주세요. 시간이 될때마다 답변을 드리겠습니다. 다음 연재에서는 장례 중, 즉 장례식의 절차와 유족이 알아야 할 사항(부고/조문 예절, 각종 행정 등) 을 정리할 계획입니다.",
  },
  {
    type: "a",
    resource: "장례 가이드북 2편 보러가기",
    href: "/content/guide/sn-2/",

    newGtm: {
      path: "content",
      trigger_and_target: "sn-1-uv_sn-2",
    },
  },
];
